import(/* webpackMode: "eager" */ "/codebuild/output/src3568723011/src/lawgue-website-v2/src/app/components/templates/PartnershipPageTemplate.tsx")